package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.PermissionType
import kotlinx.serialization.Serializable

@Serializable
enum class UserPermissionSignSymptom(private val literal: String) : PermissionType {
	添加症状("添加症状"),
	修改症状("修改症状");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "user_permission_sign_symptom"}
	override fun getLiteral(): String {return literal}
}
